export default __webpack_public_path__ + "static/media/aircare-1.ba27a454.png";